import { Documents } from "../../components/documents/Documents";

export const DocumentsContainer = () => {
  return (
    <Documents />
  );
};

export default DocumentsContainer;
